import { useState, forwardRef } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";

const PasswordInput = forwardRef(function PasswordInput(
  { className = "", testid, ...rest },
  ref
) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input
        ref={ref}
        type={show ? "text" : "password"}
        className={`pr-10 ${className}`}
        data-testid={testid}
        {...rest}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setShow((v) => !v)}
        aria-label={show ? "Şifreyi gizle" : "Şifreyi göster"}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-[#6b655c] hover:text-[#1a1a1a] transition-colors"
        data-testid={testid ? `${testid}-toggle` : "password-toggle"}
      >
        {show ? <EyeOff size={16} /> : <Eye size={16} />}
      </button>
    </div>
  );
});

export default PasswordInput;
